import {
  CalendarIcon,
  ChatIcon,
  CollectionIcon,
  DotsHorizontalIcon,
} from "@heroicons/react/outline";
import React from "react";
import { cn } from "ui/lib/utils";
import {
  sectionLinks,
  sectionSegment,
} from "apollo/components/top-navigation/links";
import { TAB_SEGMENTS, useTabBarHidden } from "./tab-bar-context";

export const TAB_ICONS = {
  chat: ChatIcon,
  overview: CalendarIcon,
  movements: CollectionIcon,
};

export const tabClass =
  "flex min-h-11 min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-lg text-[0.6875rem] font-medium select-none transition-colors active:bg-accent";

export const barClass =
  "fixed inset-x-0 bottom-0 z-40 flex h-[var(--tab-bar-height)] items-start gap-1 border-t border-border bg-background/90 pt-1 pl-[max(0.5rem,env(safe-area-inset-left))] pr-[max(0.5rem,env(safe-area-inset-right))] backdrop-blur lg:hidden";

export const tabFor = (segment: string) =>
  sectionLinks.find((section) => sectionSegment(section.href) === segment);

/**
 * The bar before its data: every tab in place, none of them live yet. The
 * server renders it, so the first paint already has the bar.
 */
export const MobileTabBarPlaceholder = () => {
  const hidden = useTabBarHidden();
  return (
    <div aria-hidden="true" className={cn(barClass, hidden && "hidden")}>
      {[...TAB_SEGMENTS, "more"].map((segment) => {
        const Icon = TAB_ICONS[segment] ?? DotsHorizontalIcon;
        return (
          <span key={segment} className={cn(tabClass, "text-muted-foreground")}>
            <Icon aria-hidden="true" className="size-6" />
            {tabFor(segment)?.name ?? "More"}
          </span>
        );
      })}
    </div>
  );
};
